var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutBackgroundOverlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 605,
    viewBox: "0 0 316 605",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1743_5731",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 316,
    height: 605
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 316,
    height: 605,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1743_5731)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1743_5731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.448 318.508C294.622 303.001 319.22 287.157 330.34 284.123C342.134 281.089 354.265 284.123 363.364 292.214C378.527 305.698 383.245 331.993 377.853 350.534C365.385 393.347 308.437 399.415 277.436 373.795C242.054 344.129 239.695 291.877 271.708 259.177C296.98 233.557 336.069 219.735 371.451 227.826C411.213 236.591 438.508 275.695 440.53 315.474C442.889 357.276 417.616 388.627 383.919 410.202C347.189 433.8 300.013 445.936 258.566 427.058C225.543 412.225 197.574 381.548 187.128 346.826C176.008 307.721 194.878 263.897 223.521 236.591C258.903 202.88 304.731 187.373 352.58 196.474C358.309 197.486 360.668 188.721 354.939 187.71C303.72 177.933 254.859 194.115 217.118 230.186C184.769 261.2 165.225 310.081 180.389 353.905C195.552 398.066 236.663 435.823 282.828 443.914C333.373 452.678 390.658 427.395 424.018 389.302C455.693 353.231 457.715 300.642 431.768 260.863C406.833 222.769 362.69 208.61 319.22 221.084C275.077 233.557 234.304 272.999 240.032 322.217C245.087 366.715 284.512 403.123 330.003 397.729C380.886 391.661 407.844 333.341 375.157 291.54C362.016 274.684 339.102 269.627 319.894 278.392C302.035 286.483 286.871 308.395 303.046 325.251C307.089 329.296 313.492 322.891 309.448 318.508Z",
    fill: "#DC9304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.92 455.374C213.745 472.229 194.201 488.074 185.44 510.323C180.722 522.122 181.059 539.314 198.245 538.64C229.246 537.292 236.322 484.365 241.04 461.779C242.725 453.351 229.92 449.98 228.235 458.408C224.865 475.263 221.833 494.142 213.408 509.312C211.387 513.02 199.593 531.561 195.549 521.448C194.201 517.739 201.614 506.615 203.636 503.581C213.071 489.085 227.224 477.286 239.018 464.813C245.421 458.745 235.985 449.306 229.92 455.374Z",
    fill: "#CA6518"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.017 379.861C122.429 382.221 95.4714 380.873 74.2423 393.008C63.1223 399.414 54.698 412.224 67.5029 422C91.7648 440.878 131.19 406.156 149.387 391.997C156.126 386.94 149.387 375.479 142.647 380.535C130.179 389.974 117.375 400.762 103.222 407.504C99.1781 409.527 86.0363 415.595 81.3187 413.235C68.5138 407.167 88.732 400.762 92.1017 399.751C109.624 394.357 128.158 394.694 146.354 393.008C154.441 392.334 154.778 378.85 146.017 379.861Z",
    fill: "#CA6518"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.972 284.459C121.08 273.671 99.8509 258.838 75.926 256.816C63.7951 255.804 49.3053 260.187 52.675 275.357C60.0884 306.708 116.025 298.617 138.603 296.932C147.027 296.258 147.027 283.11 138.603 283.785C120.743 285.133 100.862 287.83 83.3393 283.448C79.9696 282.436 60.7623 276.368 68.8496 269.963C71.8824 267.603 83.0024 271.312 86.3721 272.323C103.558 277.38 119.395 287.493 135.233 295.921C142.646 299.629 149.386 288.504 141.972 284.459Z",
    fill: "#CA6518"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.532 197.486C183.086 177.259 174.662 153.999 157.477 138.492C147.704 129.727 130.519 123.659 125.801 140.851C117.377 170.517 164.553 194.789 184.771 206.588C192.184 210.97 198.924 199.509 191.511 195.126C175.336 185.687 156.803 175.911 145.346 160.741C142.313 157.033 132.541 140.177 143.661 144.222C149.389 146.582 154.781 154.336 158.487 159.055C168.26 172.877 174.662 189.058 182.412 203.891C186.119 211.982 197.576 205.239 193.532 197.486Z",
    fill: "#CA6518"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.595 153.324C263.617 129.389 270.019 101.409 259.573 78.4852C254.519 67.3606 243.736 59.9441 232.953 70.0574C210.713 91.2954 238.344 136.468 249.127 156.695C253.171 164.111 264.628 157.706 260.584 149.953C252.497 134.108 242.725 117.59 239.692 99.7232C239.018 94.3294 239.355 75.4512 246.769 82.8676C250.812 86.5759 250.812 97.3634 251.149 102.42C252.497 119.276 249.464 136.468 247.779 153.324C247.779 161.751 260.921 161.751 261.595 153.324Z",
    fill: "#CA6518"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.406 211.645L278.113 233.22L293.614 222.095L274.406 211.645Z",
    stroke: "#D77342",
    strokeWidth: 1.1814,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.984 239.287L244.746 259.514L257.214 245.018L235.984 239.287Z",
    stroke: "#D77342",
    strokeWidth: 1.1814,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.008 282.437L225.878 301.652L233.628 279.74L207.008 282.437Z",
    stroke: "#D77342",
    strokeWidth: 1.1814,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.977 398.404L260.249 388.964L243.401 372.783L234.977 398.404Z",
    stroke: "#D77342",
    strokeWidth: 1.1814,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.802 427.732L298.999 408.18L276.422 401.438L280.802 427.732Z",
    stroke: "#D77342",
    strokeWidth: 1.1814,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.32 251.424L303.049 278.056L321.919 263.56L297.32 251.424Z",
    stroke: "#D77342",
    strokeWidth: 1.1814,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.273 296.597L284.177 312.778L288.557 289.518L262.273 296.597Z",
    stroke: "#D77342",
    strokeWidth: 1.1814,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.758 357.276L301.02 345.477L282.486 330.645L276.758 357.276Z",
    stroke: "#D77342",
    strokeWidth: 1.1814,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.617 343.792L231.608 351.546L226.216 324.914L201.617 343.792Z",
    stroke: "#D77342",
    strokeWidth: 1.1814,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.112 175.236C310.973 175.236 312.482 173.727 312.482 171.865C312.482 170.003 310.973 168.494 309.112 168.494C307.251 168.494 305.742 170.003 305.742 171.865C305.742 173.727 307.251 175.236 309.112 175.236Z",
    stroke: "#DC9304",
    strokeWidth: 0.5422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.707 178.608C271.707 181.642 269.348 184.339 265.979 184.339C262.946 184.339 260.25 181.979 260.25 178.608C260.25 175.574 262.609 172.877 265.979 172.877C269.348 173.214 271.707 175.574 271.707 178.608Z",
    stroke: "#DC9304",
    strokeWidth: 0.5422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.617 219.734C201.617 222.431 199.258 224.791 196.562 224.791C193.867 224.791 191.508 222.431 191.508 219.734C191.508 217.038 193.867 214.678 196.562 214.678C199.258 214.678 201.617 217.038 201.617 219.734Z",
    stroke: "#DC9304",
    strokeWidth: 0.5422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.535 285.133C168.373 285.133 172.296 281.209 172.296 276.368C172.296 271.528 168.373 267.604 163.535 267.604C158.696 267.604 154.773 271.528 154.773 276.368C154.773 281.209 158.696 285.133 163.535 285.133Z",
    stroke: "#DC9304",
    strokeWidth: 0.5422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.114 341.768C157.347 341.768 159.158 339.957 159.158 337.723C159.158 335.489 157.347 333.678 155.114 333.678C152.881 333.678 151.07 335.489 151.07 337.723C151.07 339.957 152.881 341.768 155.114 341.768Z",
    stroke: "#DC9304",
    strokeWidth: 0.5422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.082 387.952C183.082 391.998 180.05 395.032 176.006 395.032C171.962 395.032 168.93 391.998 168.93 387.952C168.93 383.907 171.962 380.873 176.006 380.873C179.713 380.873 183.082 383.907 183.082 387.952Z",
    stroke: "#DC9304",
    strokeWidth: 0.5422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.694 430.765C211.3 430.765 213.412 428.652 213.412 426.046C213.412 423.439 211.3 421.326 208.694 421.326C206.089 421.326 203.977 423.439 203.977 426.046C203.977 428.652 206.089 430.765 208.694 430.765Z",
    stroke: "#DC9304",
    strokeWidth: 0.5422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.957 453.014C263.957 456.048 261.598 458.745 258.228 458.745C255.196 458.745 252.5 456.385 252.5 453.014C252.5 449.98 254.859 447.283 258.228 447.283C261.598 447.283 263.957 449.643 263.957 453.014Z",
    stroke: "#DC9304",
    strokeWidth: 0.5422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.824 466.836C313.824 470.207 311.128 472.567 308.096 472.567C305.063 472.567 302.367 469.87 302.367 466.836C302.367 463.802 305.063 461.105 308.096 461.105C311.128 461.105 313.824 463.465 313.824 466.836Z",
    stroke: "#DC9304",
    strokeWidth: 0.5422,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1743_5731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 525,
    height: 503.306,
    fill: "white",
    transform: "translate(52 65)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutBackgroundOverlay);
export default __webpack_public_path__ + "static/media/about-background-overlay.bbe2bad9ddcfa598dc4da05c5229a7af.svg";
export { ForwardRef as ReactComponent };